import React, { useEffect, useContext, createContext } from 'react';
import { getInTransitJobs } from 'utils/network/http';
import { useAuth } from 'hooks/useAuth/useAuth';
import config from 'utils/constants/config';
import usePolling from 'hooks/usePolling/usePolling';
import useFetchData from 'hooks/useFetchData/useFetchData';

export const inTransitJobsContext = createContext();

export const ProvideInTransitJobs = ({ children }) => {
  const inTransitJobs = useProvideInTransitJobs();
  return (
    <inTransitJobsContext.Provider value={inTransitJobs}>
      {children}
    </inTransitJobsContext.Provider>
  );
};

export const useInTransitJobs = () => {
  return useContext(inTransitJobsContext);
};

const useProvideInTransitJobs = () => {
  const { profile } = useAuth();
  const { loading, error, data, fetchData, silentFetchData } = useFetchData({
    fetchFunc: getInTransitJobs
  });

  const { startPolling } = usePolling({
    fetchFunc: silentFetchData,
    delay: config.SLOW_POLLING_DELAY
  });

  useEffect(() => {
    if (!data && profile && !error && !loading) {
      fetchData();
      startPolling();
    }
  }, [data, fetchData, profile, error, loading, startPolling]);

  return {
    inTransitJobs: data,
    loading,
    error
  };
};
